import { render, staticRenderFns } from "./EmailSendButton.vue?vue&type=template&id=6fa982b4"
import script from "./EmailSendButton.vue?vue&type=script&lang=js"
export * from "./EmailSendButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports